// skillsData.jsx
// Skill groups for the Skills section.
//
// Each skill uses ONE of:
//   brand: an official logo from brandIcons.js (Simple Icons path + hex), or
//   fa + color: a Font Awesome class, for concepts with no logo (and for AWS /
//     Power BI, whose logos Simple Icons no longer ships), with the hover color.
// Icons always render in their brand color.

import {
  siReact,
  siTypescript,
  siJavascript,
  siHtml5,
  siCss,
  siNodedotjs,
  siExpress,
  siPytorch,
  siTensorflow,
  siScikitlearn,
  siLangchain,
  siPython,
  siPandas,
  siApachespark,
  siApachekafka,
  siGit,
  siDocker,
  siKubernetes,
  siMongodb,
  siFirebase,
} from "./brandIcons";

export const skillGroups = [
  {
    id: "web-development",
    title: "Web Development",
    description:
      "Building responsive and interactive user interfaces with modern frameworks and libraries, alongside robust server-side applications and APIs.",
    icon: "fas fa-laptop-code",
    skills: [
      { name: "React", brand: siReact },
      { name: "TypeScript", brand: siTypescript },
      { name: "JavaScript", brand: siJavascript },
      { name: "HTML5", brand: siHtml5 },
      { name: "CSS3", brand: siCss },
      { name: "Node.js", brand: siNodedotjs },
      { name: "Express.js", brand: siExpress },
      { name: "REST APIs", fa: "fas fa-plug", color: "#4a77e5" },
    ],
  },
  {
    id: "ai-ml",
    title: "AI & Machine Learning",
    description:
      "Building and integrating intelligent systems — from training deep learning models to engineering LLM-powered applications with prompting and retrieval.",
    icon: "fas fa-brain",
    skills: [
      { name: "PyTorch", brand: siPytorch },
      { name: "TensorFlow", brand: siTensorflow },
      { name: "Scikit-learn", brand: siScikitlearn },
      { name: "Deep Learning", fa: "fas fa-circle-nodes", color: "#8b5cf6" },
      { name: "LLMs", fa: "fas fa-robot", color: "#d9467a" },
      {
        name: "Prompt Engineering",
        fa: "fas fa-wand-magic-sparkles",
        color: "#e0922f",
      },
      { name: "RAG", fa: "fas fa-magnifying-glass", color: "#0d9488" },
      { name: "LangChain", brand: siLangchain },
    ],
  },
  {
    id: "data-analytics",
    title: "Data & Analytics",
    description:
      "Leveraging data to uncover insights, build predictive models, and support informed decision-making.",
    icon: "fas fa-chart-line",
    skills: [
      { name: "Python", brand: siPython },
      { name: "SQL", fa: "fas fa-database", color: "#00758f" },
      { name: "Pandas", brand: siPandas },
      { name: "Apache Spark", brand: siApachespark },
      { name: "Power BI", fa: "fas fa-chart-column", color: "#e8b007" },
      { name: "Apache Kafka", brand: siApachekafka },
    ],
  },
  {
    id: "devops-cloud",
    title: "DevOps & Cloud",
    description:
      "Experience with deployment pipelines, containerization, and scalable cloud infrastructure.",
    icon: "fas fa-cloud",
    skills: [
      { name: "Git", brand: siGit },
      { name: "Docker", brand: siDocker },
      { name: "Kubernetes", brand: siKubernetes },
      { name: "AWS", fa: "fab fa-aws", color: "#ff9900" },
      { name: "CI/CD", fa: "fas fa-infinity", color: "#2088ff" },
      { name: "MongoDB", brand: siMongodb },
      { name: "Firebase", brand: siFirebase },
    ],
  },
];
